module.exports={ apiUrl: process.env.NODE_ENV==="development"?"https://api.client.uhc.ca": "https://api.client.uhc.ca", getAllCountries: "https://restcountries.eu/rest/v2/all?fields=name;languages;callingCodes", };
